import { useEffect, useState } from 'react';
import { BrandRingMark, LoaderOverlay } from '@exam-prep/ui';

/** Wait this long before showing the loader, so fast loads never flash it. */
const ADMIN_LOADER_DELAY_MS = 200;

/** The SSCExamPrep badge in a teal/amber ring with the label. */
function AdminLoaderMark({ label = 'Loading…' }: { label?: string | undefined }) {
  return (
    <div role="status" aria-live="polite" className="admin-loader">
      <BrandRingMark block="admin-loader" badgeSize={28} />
      <span className="text-sm text-muted-foreground">{label}</span>
    </div>
  );
}

/**
 * Page loader (and Suspense fallback): nothing for the first moment, then the branded loader
 * centred on a full-screen overlay that blocks the page until it has loaded.
 */
export function AdminLoader({ label }: { label?: string | undefined }) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), ADMIN_LOADER_DELAY_MS);
    return () => clearTimeout(timer);
  }, []);
  return visible ? (
    <LoaderOverlay label={label ?? 'Loading…'}>
      <AdminLoaderMark label={label} />
    </LoaderOverlay>
  ) : null;
}
